"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAppErrorLogSchema = exports.ErrorResponseSchema = exports.EntityIdParamsSchema = exports.EntityIdResponseSchema = exports.SearchQuerySchema = void 0;
const zod_1 = require("zod");
__exportStar(require("./address.types"), exports);
__exportStar(require("./admin.types"), exports);
__exportStar(require("./googleCalendar.types"), exports);
__exportStar(require("./appointments.types"), exports);
__exportStar(require("./atGlance.types"), exports);
__exportStar(require("./attachment.types"), exports);
__exportStar(require("./betaUserInvitation.types"), exports);
__exportStar(require("./companies.types"), exports);
__exportStar(require("./customer.types"), exports);
__exportStar(require("./customHeaders"), exports);
__exportStar(require("./email.types"), exports);
__exportStar(require("./invoices.types"), exports);
__exportStar(require("./jobs.types"), exports);
__exportStar(require("./priceBook.types"), exports);
__exportStar(require("./quotes.types"), exports);
__exportStar(require("./reporting.types"), exports);
__exportStar(require("./region.types"), exports);
__exportStar(require("./sharedStatus.types"), exports);
__exportStar(require("./signupTier.types"), exports);
__exportStar(require("./tax.types"), exports);
__exportStar(require("./termsAndConditions.types"), exports);
__exportStar(require("./todos.types"), exports);
__exportStar(require("./twoFactor.types"), exports);
__exportStar(require("./transactionalEmailBody.types"), exports);
__exportStar(require("./userInvitation.types"), exports);
__exportStar(require("./userPermission.types"), exports);
__exportStar(require("./users.types"), exports);
__exportStar(require("./notifications.types"), exports);
__exportStar(require("./portalQuote.types"), exports);
exports.SearchQuerySchema = zod_1.z.object({
    search: zod_1.z.string().optional(),
});
exports.EntityIdResponseSchema = zod_1.z.object({
    data: zod_1.z.object({ id: zod_1.z.string() }),
});
exports.EntityIdParamsSchema = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.ErrorResponseSchema = zod_1.z.object({
    data: zod_1.z.null(),
    error: zod_1.z.object({
        message: zod_1.z.string(),
    }),
});
exports.CreateAppErrorLogSchema = zod_1.z.object({
    message: zod_1.z.string().optional(),
    stack: zod_1.z.string().optional(),
});
